import React from 'react';
import NumberFormat from 'react-number-format';
import { useController } from 'react-hook-form';

import { Select } from 'ui-components/v2/Select';
import { MenuItem } from 'ui-components/v2/MenuItem';
import { PurchaseFormFieldNames as FIELD_NAMES } from 'constants/form';
import { ShippingMethodTypesSelectProps } from './interface';

export function ShippingMethodTypesSelect({
  control,
  shippingMethodTypes,
}: ShippingMethodTypesSelectProps) {
  const {
    field: { ref, ...shippingMethodTypeField },
  } = useController({
    name: FIELD_NAMES.shippingMethodType,
    defaultValue: shippingMethodTypes[0].id,
    control,
  });

  return (
    <Select
      fullWidth
      id={`${shippingMethodTypeField.name}-select`}
      variant="outlined"
      label="Transit time"
      {...shippingMethodTypeField}
    >
      {shippingMethodTypes.map((method) => (
        <MenuItem key={method.name} value={method.id}>
          <span className="text-lg">
            {method.transit_time} {method.transit_time > 1 ? 'days' : 'day'}
          </span>
          {method.shipping_price_diff ? (
            <NumberFormat
              value={method.shipping_price_diff.toFixed(2)}
              className="text-lg"
              displayType="text"
              thousandSeparator
              prefix=", +$"
            />
          ) : null}
        </MenuItem>
      ))}
    </Select>
  );
}
